export default __webpack_public_path__ + "static/media/pro-elevate-bpn-2.975705a5.png";